import React from 'react';
import { Layout, Button, Typography, Flex, Avatar } from 'antd';
import { LeftOutlined, RightOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../Shared/GlobalContext/ThemeContext';
import { RTL_LANGUAGES } from '../../../../Constants/language';
import MessageActions from './MessageActions';

const { Header } = Layout;
const { Text } = Typography;

const MessageHeader = ({
  screens,
  onBack,
  isIgnored,
  isSnoozed,
  isAdmin,
  updateContactStatus,
  selectedConversation,
  onToggleTickets,
  showTickets
}) => {
  const { isDarkMode } = useTheme();
  const { i18n } = useTranslation();
  const isRTL = RTL_LANGUAGES.includes(i18n.language?.split('-')[0]);
  const contentBorderColor = isDarkMode ? '#434343' : '#f0f0f0';
  const themeColors = {
    background: isDarkMode ? '#1f1f1f' : '#fff',
    border: isDarkMode ? '#434343' : '#f0f0f0',
    secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)',
    text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
  };
  return (
    <Header style={{
      padding: '8px',
      height: 'auto',
      lineHeight: 'normal',
      background: themeColors.background,
      transition: 'background 0.3s ease, border-color 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: `1px solid ${contentBorderColor}`,
      overflowX: 'auto',
      overflowY: 'hidden',
      scrollbarWidth: 'thin'
    }}>
      <Flex align="center" style={{ flexShrink: 0, marginInlineEnd: 16 }}>
        {screens.xs &&
          <Button
            type="text"
            onClick={onBack}
            icon={isRTL ? <RightOutlined style={{ color: themeColors.text }} /> : <LeftOutlined style={{ color: themeColors.text }} />}
            style={{ padding: 0, marginInlineEnd: 10, }}
          />
        }
        <Avatar
          src={selectedConversation?.contact?.picture_url}
          icon={!selectedConversation?.contact?.picture_url && <UserOutlined />}
          style={{ marginInlineEnd: 8, visibility: selectedConversation ? 'visible' : 'hidden' }}
        />
        <Text strong style={{ color: themeColors.text }}>
          {selectedConversation?.contact?.first_name} {selectedConversation?.contact?.last_name}
        </Text>
      </Flex>
      {selectedConversation && (
        <MessageActions
          screens={screens}
          isIgnored={isIgnored}
          isSnoozed={isSnoozed}
          isAdmin={isAdmin}
          updateContactStatus={updateContactStatus}
          selectedConversation={selectedConversation}
          onToggleTickets={onToggleTickets}
          showTickets={showTickets}
        />
      )}
    </Header>
  );
};

export default MessageHeader;
